import React, { Component } from "react";

import { CButton, CSpinner, CSwitch, CTooltip } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import QuestionCreatorBottomMenu from "./QuestionCreatorBottomMenu/QuestionCreatorBottomMenu";
import QuestionCreatorFeedbackMenu from "./QuestionCreatorFeedbackMenu/QuestionCreatorFeedbackMenu";
import QuestionCreatorHeaderMenu from "./QuestionCreatorHeaderMenu/QuestionCreatorHeaderMenu";
import QuestionCreatorItemsMenu from "./QuestionCreatorItemsMenu/QuestionCreatorItemsMenu";
import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import TextEditor from "../../TextEditor/TextEditor";

import "./styles.css";

class QuestionCreator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: true,
      loadingData: true,
      nonTimerCalls: 0,
      key: false,
      grade: 10,
      author: this.props.user.user.name,
      user_id: null,
      year: new Date().getFullYear(),
      module: this.props.module || null,
      abilityObjective: this.props.filter.ability
        ? this.props.filter.objective || null
        : null,
      moduleObjective: this.props.filter.module
        ? this.props.filter.objective || null
        : null,
      difficultyLevel: this.props.filter.difficulty || 1,
      questionDescription: null,
      currentQuestionTypeId: this.props.filter.type || 1,
      items: [
        {
          itemIndex: 0,
          description: '[{"type":"paragraph","children":[{"text":""}]}]',
          itemFeedbackOn: false,
          feedback: null,
          check: true,
          fatherItemId: null,
          newItem: false
        },
        {
          itemIndex: 1,
          description: '[{"type":"paragraph","children":[{"text":""}]}]',
          feedback: null,
          check: false,
          fatherItemId: null,
          newItem: true
        }
      ],
      questionFeedback: null,
      questionFeedbackOn: false,
      released: false,
      private: true,
      moreInfo: true,
      saving: false,
      grades: [
        {
          grade: 1,
          name: "1º ano"
        },
        {
          grade: 2,
          name: "2º ano"
        },
        {
          grade: 3,
          name: "3º ano"
        },
        {
          grade: 4,
          name: "4º ano"
        },
        {
          grade: 5,
          name: "5º ano"
        },
        {
          grade: 6,
          name: "6º ano"
        },
        {
          grade: 7,
          name: "7º ano"
        },
        {
          grade: 8,
          name: "8º ano"
        },
        {
          grade: 9,
          name: "9º ano"
        },
        {
          grade: 10,
          name: "1ª série"
        },
        {
          grade: 11,
          name: "2ª série"
        },
        {
          grade: 12,
          name: "3ª série"
        }
      ],
      types: [
        {
          id: 1,
          name: "Discursiva"
        },
        {
          id: 2,
          name: "Múltipla Escolha"
        },
        {
          id: 3,
          name: "Múltipla Resposta"
        },
        {
          id: 4,
          name: "Verdadeiro ou Falso"
        }
      ],
      abilities: [],
      discipline: this.props.filter.discipline || null,
      segment: this.props.segment || null
    };

    this.typeChanger = this.handleTypeChange.bind(this);

    this.changeQuestionDescriptionContent.bind(this);

    this.showMoreInfo = this.toggleMoreInfo.bind(this);
    this.toggleQuestionFeedback =
      this.changeQuestionFeedbackExibition.bind(this);
    this.changeQuestionFeedback = this.changeQuestionFeedbackContent.bind(this);
    this.yearChanger = this.changeQuestionYear.bind(this);
    this.authorChanger = this.changeAuthor.bind(this);
    this.gradeChanger = this.changeGrade.bind(this);
    this.difficultyChanger = this.changeDifficultyLevel.bind(this);
    this.abilityChanger = this.changeAbility.bind(this);
    this.moduleChanger = this.changeModule.bind(this);
    this.privateChanger = this.changePrivate.bind(this);
    this.segmentChanger = this.changeSegment.bind(this);
    this.disciplineChanger = this.changeDiscipline.bind(this);

    this.dataUpdater = this.updateData.bind(this);

    this.questionDeleter = this.deleteQuestion.bind(this);
    this.questionDuplicator = this.duplicateQuestion.bind(this);
    this.onFinish = this.onFinish.bind(this);
  }

  componentDidMount() {
    let editParamId = this.props.questionId;

    if (!editParamId) this.setState({ loadingData: false });
    else this.pullQuestionInfo();

    axios
      .get(`${URL.api}evaluation/type_question/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState({
            types: resp.data.data
          });
        }
      });
  }

  handleReset = () => {
    this.setState({ key: true });
  };

  createNewQuestion(duplicatedObj, __duplicatedQuestion) {
    const itemsToFilter = this.state.items.filter(item => !item.newItem);
    const itemsToSend = itemsToFilter.map(item => {
      item = {
        description: item.description,
        check_value: item.check,
        feedback: item.feedback,
        father_option_id: item.fatherItemId
      };

      return item;
    });

    if (
      !this.state.module ||
      !this.state.author ||
      !this.state.year ||
      !this.state.difficultyLevel
    ) {
      toastr.warning("Atenção", "Preencha todas as configurações!");
      this.setState({ saving: false });
      return;
    }

    const obj = {
      id: this.props.questionId,
      description: this.state.questionDescription,
      feedback: this.state.questionFeedback,
      grade: this.state.grade,
      author: this.state.author,
      year: this.state.year,
      module_id: this.state.module,
      ability_id: this.state.ability,
      L_id: 1,
      difficulty_level_id: this.state.difficultyLevel,
      type_question_id: this.state.currentQuestionTypeId,
      objective_id: this.state.abilityObjective,
      user_id: this.props.user.user.id,
      source_id: 1,
      released: this.state.released,
      private: this.state.private,
      canceled: false,
      segment_id: this.state.segment,
      discipline_id: this.state.discipline,
      options: itemsToSend
    };

    axios
      .post(`${URL.api}evaluation/question/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState({
            loadingData: false,
            saving: false,
            ability: null,
            module: null,
            abilityObjective: null,
            moduleObjective: null,
            questionDescription: null,
            currentQuestionTypeId: 1
          });

          this.props.onSave({ ...obj, id: resp.data.data }, false);
          toastr.success("Sucesso", "Questão criada com sucesso!");
          this.handleReset();
        }
      });
  }

  pullQuestion(editParamId) {
    axios
      .get(`${URL.api}evaluation/question/singleView/${editParamId}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          const feedbackOn =
            resp.data.data.feedback &&
            resp.data.data.feedback !==
              '[{"type":"paragraph","children":[{"text":""}]}]';

          let items = resp.data.data.options.map((item, index) => {
            const itemFeedbackOn = item.feedback !== null;

            item = {
              id: item.id,
              itemIndex: index,
              description: item.description,
              itemFeedbackOn,
              feedback: item.feedback,
              check: item.check_value,
              fatherItemId: item.father_option_id,
              newItem: false
            };

            return item;
          });

          if (resp.data.data.options.length === 0) {
            items = [
              {
                itemIndex: 0,
                description: '[{"type":"paragraph","children":[{"text":""}]}]',
                itemFeedbackOn: false,
                feedback: null,
                check: true,
                fatherItemId: null,
                newItem: false
              }
            ];
          }

          items.push({
            itemIndex: items.length,
            description: '[{"type":"paragraph","children":[{"text":""}]}]',
            itemFeedbackOn: false,
            feedback: null,
            check: false,
            fatherItemId: null,
            newItem: true
          });

          this.setState({
            loadingData: false,
            grade: resp.data.data.grade,
            author: resp.data.data.author,
            user_id: resp.data.data.user_id,
            year: resp.data.data.year,
            difficultyLevel: resp.data.data.difficulty_level_id,
            questionDescription: resp.data.data.description,
            currentQuestionTypeId: resp.data.data.type_question_id,
            items,
            questionFeedbackOn: feedbackOn,
            questionFeedback: resp.data.data.feedback,
            released: resp.data.data.released,
            private: resp.data.data.private,
            ability: resp.data.data.ability_id,
            module: resp.data.data.module_id
          });
        }
      });
  }

  pullQuestionInfo() {
    console.log("this.props", this.props);
    const feedbackOn =
      this.props.questionInfo?.feedback &&
      this.props.questionInfo?.feedback !==
        '[{"type":"paragraph","children":[{"text":""}]}]';

    let items = this.props.questionInfo?.options?.map((item, index) => {
      const itemFeedbackOn = item.feedback !== null;

      item = {
        id: item.id,
        itemIndex: index,
        description: item.description,
        itemFeedbackOn,
        feedback: item.feedback,
        check: item.check_value,
        fatherItemId: item.father_option_id,
        newItem: false
      };

      return item;
    });

    if (this.props.questionInfo?.options?.length === 0) {
      items = [
        {
          itemIndex: 0,
          description: '[{"type":"paragraph","children":[{"text":""}]}]',
          itemFeedbackOn: false,
          feedback: null,
          check: true,
          fatherItemId: null,
          newItem: false
        }
      ];
    }

    items.push({
      itemIndex: items.length,
      description: '[{"type":"paragraph","children":[{"text":""}]}]',
      itemFeedbackOn: false,
      feedback: null,
      check: false,
      fatherItemId: null,
      newItem: true
    });

    this.setState({
      loadingData: false,
      grade: this.props.questionInfo.grade,
      author: this.props.questionInfo.author,
      user_id: this.props.questionInfo.user_id,
      year: this.props.questionInfo.year,
      questionDescription: this.props.questionInfo.description,
      currentQuestionTypeId: this.props.questionInfo.type_question_id,
      difficultyLevel: this.props.questionInfo.difficulty_level_id,
      items,
      questionFeedbackOn: feedbackOn,
      questionFeedback: this.props.questionInfo.feedback,
      released: this.props.questionInfo.released,
      private: this.props.questionInfo.private,
      ability: this.props.questionInfo.ability_id,
      module: this.props.questionInfo.module_id,
      discipline: this.props.questionInfo.discipline_id,
      segment: this.props.segment || this.props.questionInfo.segment_id
    });
  }

  deleteQuestion() {
    return this.props.questionDeleter(this.props.index);
  }

  duplicateQuestion() {}

  updateData() {
    this.setState(prevState => ({
      nonTimerCalls: prevState.nonTimerCalls + 1
    }));

    const itemsToFilter = this.state.items.filter(item => !item.newItem);
    const itemsToSend = itemsToFilter.map(item => {
      item = {
        id: item.id,
        description: item.description,
        check_value: item.check,
        feedback: item.feedback,
        father_option_id: item.fatherItemId
      };

      return item;
    });

    if (
      !this.state.module ||
      !this.state.author ||
      !this.state.year ||
      !this.state.difficultyLevel
    ) {
      toastr.warning("Atenção", "Preencha todas as configurações!");
      this.setState({ saving: false });
      return;
    }

    const obj = {
      id: this.props.questionId,
      description: this.state.questionDescription,
      feedback: this.state.questionFeedback,
      grade: this.state.grade,
      author: this.state.author,
      module_id: this.state.module,
      ability_id: this.state.ability,
      objective_id: this.state.abilityObjective,
      L_id: 1,
      difficulty_level_id: this.state.difficultyLevel,
      type_question_id: this.state.currentQuestionTypeId,
      user_id: this.state.user_id,
      source_id: 1,
      released: this.state.released,
      private: this.state.private,
      segment_id: this.state.segment,
      discipline_id: this.state.discipline,
      canceled: false,
      options: itemsToSend
    };

    axios
      .post(`${URL.api}evaluation/question/update`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (!resp.data.success) {
          this.setState({ saving: false });
          return;
        }

        const isModal = typeof this.props.handleIsSaved === "function";

        if (isModal) {
          // fluxo modal (/evaluation/create)
          this.props.handleIsSaved(obj, true);
          this.props.onSave(obj, true);
          this.setState({ saving: false });
        } else {
          // fluxo question/bank
          this.props.onSave(obj, true);
          this.setState(
            {
              saving: false,
              ability: null,
              module: null,
              abilityObjective: null,
              moduleObjective: null,
              questionDescription: null,
              currentQuestionTypeId: 1,
              items: [
                {
                  itemIndex: 0,
                  description:
                    '[{"type":"paragraph","children":[{"text":""}]}]',
                  itemFeedbackOn: false,
                  feedback: null,
                  check: true,
                  fatherItemId: null,
                  newItem: false
                },
                {
                  itemIndex: 1,
                  description:
                    '[{"type":"paragraph","children":[{"text":""}]}]',
                  feedback: null,
                  check: false,
                  fatherItemId: null,
                  newItem: true
                }
              ]
            },
            () => this.handleReset()
          );
        }

        toastr.success("Sucesso", "Questão atualizada com sucesso!");
      })
      .catch(err => {
        console.error(err);
        this.setState({ saving: false });
      });
  }

  handleTypeChange(newTypeId) {
    let changeToRadioHandler = 0;
    this.state.items.map(item => {
      item.check && ++changeToRadioHandler;
    });

    if (newTypeId === 2 && changeToRadioHandler > 1) {
      const itemToSave = this.state.items.find(item => item.check).itemIndex;

      const items = this.state.items.map((item, index) => {
        if (index !== itemToSave) {
          item = {
            itemIndex: item.itemIndex,
            description: item.description,
            itemFeedbackOn: item.itemFeedbackOn,
            feedback: item.feedback,
            check: false,
            fatherItemId: item.fatherItemId,
            newItem: item.newItem
          };
        }
        return item;
      });

      this.setState(() => ({
        currentQuestionTypeId: newTypeId,
        items
      }));
    } else {
      this.setState(() => ({ currentQuestionTypeId: newTypeId }));
    }
  }

  changeQuestionDescriptionContent = newDescription => {
    if (this.state.flag) {
      this.setState({ flag: false });
      this.setState(
        {
          questionDescription: JSON.stringify(newDescription)
        },
        () => {
          this.setState({ flag: true });
        }
      );
    }
  };

  changeQuestionFeedbackExibition() {
    this.setState(prevState => ({
      questionFeedbackOn: !prevState.questionFeedbackOn
    }));
  }

  changeQuestionFeedbackContent(newFeedback) {
    if (this.state.flag) {
      this.setState({ flag: false });
      this.setState(
        {
          questionFeedback: JSON.stringify(newFeedback)
        },
        () => {
          this.setState({ flag: true });
        }
      );
    }
  }

  changeQuestionYear(newYear) {
    this.setState({ year: newYear });
  }

  changeAuthor(newAuthor) {
    this.setState({ author: newAuthor });
  }

  changeGrade(newGrade) {
    this.setState(() => ({ grade: newGrade }));
  }

  changeDifficultyLevel(newLevel) {
    this.setState(() => ({ difficultyLevel: newLevel }));
  }

  changeModule(newModule, newObjective) {
    this.setState(() => ({ module: newModule, moduleObjective: newObjective }));
  }

  changeAbility(newAbility, newObjective) {
    this.setState(() => ({
      ability: newAbility,
      abilityObjective: newObjective
    }));
  }

  changePrivate(newPrivate) {
    this.setState(() => ({ private: newPrivate }));
  }

  toggleMoreInfo() {
    this.setState(prev => {
      !prev.moreInfo;
    });
  }

  changeSegment(newSegment) {
    this.setState(() => ({ segment: newSegment }));
  }

  changeDiscipline(newDiscipline) {
    this.setState(() => ({ discipline: newDiscipline }));
  }

  onFinish() {
    this.setState({ saving: true });

    if (this.props.questionId) {
      this.updateData();
    } else {
      this.createNewQuestion();
    }
  }

  render() {
    const canEdit =
      !this.props.questionId ||
      this.props.user.user.id === this.state.user_id ||
      this.props.general.active_roles.role_id === 1;

    return (
      <>
        {this.state.loadingData === false ? (
          <div className="question-creator-container" key={this.state.key}>
            <div className="d-inline-flex justify-content-between w-100 mb-2">
              <h5>Cadastro de Questão</h5>
              <div className="d-inline-flex align-items-center">
                <span className="mr-2">
                  {this.state.private ? `Privada` : `Pública`}
                </span>

                <CSwitch
                  color="primary"
                  shape="pill"
                  checked={this.state.private}
                  disabled={
                    !(
                      this.props.general.active_roles.role_id === 2 ||
                      this.props.general.active_roles.role_id === 1
                    )
                  }
                  onChange={e => this.privateChanger(e.target.checked)}
                />
              </div>
            </div>
            <QuestionCreatorBottomMenu
              showQuestionFeedback={this.state.questionFeedbackOn}
              toggleQuestionFeedback={this.toggleQuestionFeedback}
              changeQuestionFeedback={this.changeQuestionFeedback}
              feedbackContent={this.state.questionFeedback}
              questionId={this.props.questionId}
              onActivity={false}
              updater={() => null}
              history={this.props.history}
              moreInfo={this.state.moreInfo}
              showMoreInfo={this.showMoreInfo}
              author={this.state.author}
              authorChanger={this.authorChanger}
              questionYear={this.state.year}
              yearChanger={this.yearChanger}
              grades={this.state.grades}
              gradeChanger={this.gradeChanger}
              difficultyChanger={this.difficultyChanger}
              abilities={this.state.abilities}
              abilityChanger={this.abilityChanger}
              modules={this.state.modules}
              moduleChanger={this.moduleChanger}
              abilityObjective={this.state.abilityObjective}
              moduleObjective={this.state.moduleObjective}
              private={this.state.private}
              privateChanger={this.privateChanger}
              readOnly={!canEdit}
              segmentChanger={this.segmentChanger}
              disciplineChanger={this.disciplineChanger}
              itemTypes={this.state.types}
              typeChanger={this.typeChanger}
              key={this.state.key}
              difficultyLevel={this.state.difficultyLevel}
              segment={this.state.segment}
              discipline={this.state.discipline}
              module={this.state.module}
              ability={this.props.ability}
              currentTypeId={this.state.currentQuestionTypeId}
            />
            <TextEditor
              userId={this.props.user.user.id}
              editorType={{ name: "description", id: 1 }}
              questionId={this.props.questionId}
              changeQuestionDescription={this.changeQuestionDescriptionContent}
              textContent={this.state.questionDescription}
              readOnly={!canEdit}
              updater={() => null}
              key={this.state.key}
            />
            {this.state.currentQuestionTypeId !== 1 && (
              <QuestionCreatorItemsMenu
                questionState={this.state}
                itemsData={this.state.items}
                updater={() => null}
                updateState={e => this.setState(e)}
                readOnly={!canEdit}
              />
            )}
            <QuestionCreatorFeedbackMenu
              showQuestionFeedback={this.state.questionFeedbackOn}
              toggleQuestionFeedback={this.toggleQuestionFeedback}
              changeQuestionFeedback={this.changeQuestionFeedback}
              feedbackContent={this.state.questionFeedback}
              questionId={this.props.questionId}
              onActivity={false}
              updater={() => null}
              history={this.props.history}
              moreInfo={this.state.moreInfo}
              showMoreInfo={this.showMoreInfo}
              readOnly={!canEdit}
              key={this.state.key}
            />
            <p>Modulo: {this.state.module}</p>
            <div className="d-flex justify-content-end">
              <CTooltip
                content="Marque ao menos uma alternativa como correta antes de salvar."
                placement="top"
                trigger="manual"
                visible={this.state.showTooltip}
              >
                <CButton
                  color="primary"
                  onClick={() => {
                    const { currentQuestionTypeId, items } = this.state;
                    const hasCorrect = items?.some(opt => opt.check);

                    // Só exige alternativa correta se for questão de múltipla escolha (ID 1)
                    if (
                      (currentQuestionTypeId === 2 ||
                        currentQuestionTypeId === 3) &&
                      !hasCorrect
                    ) {
                      this.setState({ showTooltip: true });
                      toastr.warning(
                        "Atenção",
                        "Em questões de múltipla escolha, é obrigatório marcar uma alternativa como correta."
                      );
                      setTimeout(
                        () => this.setState({ showTooltip: false }),
                        3000
                      );
                      return;
                    }

                    this.onFinish();
                  }}
                  disabled={this.state.saving}
                >
                  <span style={this.state.saving ? { opacity: 0 } : null}>
                    <i className="fa fa-save mr-2"></i>Salvar
                  </span>
                  {this.state.saving && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </CButton>
              </CTooltip>
            </div>
          </div>
        ) : (
          <div className="question-creator-container m-0">
            <div className="d-flex justify-content-between">
              <div
                className="question-creator-skeleton"
                style={{ width: "28%", height: "1rem", margin: "8px 0" }}
              />
              <div
                className="question-creator-skeleton"
                style={{ width: "32%", height: "1rem", margin: "8px 0" }}
              />
            </div>
            <div className="my-2">
              <div
                className="question-creator-skeleton"
                style={{ width: "90%", height: "1.5rem", margin: "8px 0" }}
              />
              <div
                className="question-creator-skeleton"
                style={{ width: "30%", height: "1.5rem", margin: "8px 0" }}
              />
            </div>
            <div
              className="question-creator-skeleton"
              style={{ width: "100%", height: "8rem", margin: "8px 0" }}
            />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logout, setObj }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionCreator);
